import { Link } from "react-router-dom";

export default function HomeCta() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20waves%20in%20coral%20amber%20and%20deep%20plum%2C%20soft%20grain%20texture%2C%20minimal%20artistic%20background%2C%20elegant%20modern%20poster%2C%20no%20people%2C%20no%20text&width=1600&height=700&seq=gt-cta-band&orientation=landscape"
        alt="瓜田黑料补课入口背景：暖色抽象渐变"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/75 to-secondary-950/80" />
      <div className="relative z-10 w-full px-4 md:px-10 py-16 md:py-24">
        <div className="max-w-2xl">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-background-50 leading-tight">
            两小时看完一整年，
            <br />
            补课从这份目录开始。
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/90">
            年度盘点、TOP榜、名场面、人物志与经典案例，全部按主题整理好。你可以从任意栏目切入，也可以顺着时间线一次看完。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/rankings"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-trophy-line" />
              打开年度 TOP 榜
            </Link>
            <Link
              to="/moments"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 backdrop-blur text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-movie-2-line" />
              浏览名场面合集
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}